// iter87.227 — Single source of truth for "pot playoffs" templates
// (MLB/NBA Playoffs: Team Pick Pot + Champions Pick + Series
// Predictor — no group stage, no bracket-advancement reach points,
// no third-place playoff, no Matchday Boost). Mirrors the backend's
// `mlb_engine.MLB_PLAYOFFS_TEMPLATE` / `nba_engine.NBA_PLAYOFFS_TEMPLATE`.
// Added after a user-reported bug: the Scoring tab was rendering the
// generic soccer/World-Cup fields (stage decay, third place, group
// stage) for these templates instead of their real scoring shape.
export const POT_PLAYOFFS_LABELS = {
    mlb_playoffs_api: "MLB Playoffs",
    nba_playoffs_api: "NBA Playoffs",
};

export const isPotPlayoffsTemplate = (template) => Object.prototype.hasOwnProperty.call(POT_PLAYOFFS_LABELS, template);
